import { createContext, useContext, useEffect, useState, useCallback, useRef } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext(null);
export const useSite = () => useContext(SiteContext);

import { applyTheme, normalizeTheme } from "@/lib/theme";

const FALLBACK = {
  hero: {
    eyebrow: "Skilled support for your everyday operations",
    headline: "Your team, ready for the work ahead.",
    subtext: "Trained remote specialists who handle the work, so you can stay focused on what matters most.",
    cards: ["E-commerce Specialist", "Real Estate Operations", "Appointment Setter"],
    urgency_text: "Specialists available this week — limited slots",
    urgency_enabled: true,
  },
  talent: {
    categories: [
      { name: "E-commerce Specialists", count: 40 },
      { name: "Real Estate VAs", count: 120 },
      { name: "Social Media Managers", count: 60 },
      { name: "Appointment Setters", count: 35 },
      { name: "Admin & Executive Assistants", count: 50 },
      { name: "Cold Calling Specialists", count: 25 },
    ],
  },
  process: {
    steps: [
      { title: "Discover", description: "Tell us what you need and the kind of support you're looking for." },
      { title: "Assess", description: "We review your requirements and match you with qualified specialists." },
      { title: "Prepare", description: "Your specialist receives role-specific training and tool setup." },
      { title: "Match", description: "We introduce your new team member and get you started." },
    ],
  },
  packages: {
    packages: [
      { name: "Flexible Support", description: "Get help with specific tasks or short-term needs.", items: ["Agreed hours of support", "Role matching", "Onboarding and tool setup", "Ongoing communication"], recommended: false },
      { name: "Dedicated Specialist", description: "Work with a trained specialist focused on your business.", items: ["Dedicated specialist for your team", "Agreed hours per week", "Role-specific training and onboarding", "Regular check-ins and reporting"], recommended: true },
      { name: "Managed Team", description: "Build a team for larger or ongoing operational needs.", items: ["Multiple specialists across roles", "Custom team structure", "Onboarding and ongoing management", "Regular reporting and performance reviews"], recommended: false },
    ],
  },
  promo: { enabled: true, label: "Only a few spots left this week", headline: "Before you go —", message: "Book a free consultation this week and meet your first specialist candidate within 48 hours.", cta_text: "Book a Free Consultation" },
  availability: { blocked_dates: [], time_slots: [] },
  theme: normalizeTheme(null),
  team: [],
  testimonials: [],
};

export function SiteProvider({ children }) {
  const [content, setContent] = useState(FALLBACK);
  const [bookingOpen, setBookingOpen] = useState(false);
  const [bookingPkg, setBookingPkg] = useState(null);
  const [bookingType, setBookingType] = useState("booking");

  useEffect(() => {
    api.get("/content").then(({ data }) => setContent((c) => ({ ...c, ...data }))).catch(() => {});
  }, []);

  useEffect(() => {
    applyTheme(content.theme);
  }, [content.theme]);

  const openBooking = useCallback((pkg = null, type = "booking") => {
    setBookingPkg(pkg);
    setBookingType(type);
    setBookingOpen(true);
    api.post("/track", { type: "event", name: type === "quote" ? "quote_click" : "booking_open", path: "/" }).catch(() => {});
  }, []);

  return (
    <SiteContext.Provider value={{ content, openBooking, bookingOpen, setBookingOpen, bookingPkg, bookingType }}>
      {children}
    </SiteContext.Provider>
  );
}
